<div class="pl-4">
  <app-tree-node [node]="treeData"
                 (selectionChange)="onSelectionChange()">
  </app-tree-node>
</div>
